const selectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]')
  };
  class templateCollectionJS {
    constructor() {
        this.readMore();
        this.formScroll();
        this.selectMaterialform();
        //this.sortProducts();
    }

    // Read More and Read Less
    readMore(){
        if(selectors.readMoreBtn){
            selectors.readMoreBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                let readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
                if(readMoreEle){ 
                    if(selectors.readMoreContainer.classList.contains('open')){
                        Utility.toggleElement(selectors.readMoreContainer, 'close');
                        currentTarget.innerHTML = 'Read More'
                    }else{
                        Utility.toggleElement(selectors.readMoreContainer, 'open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }

    /**
     * display the bottom fixed form 
     * 
     */
    formScroll(){
        document.addEventListener('scroll' , () => {
             // Create a new Intersection Observer
            const observer = new IntersectionObserver( entries => {
            entries.forEach(entry => {
                entry.isIntersecting ? document.querySelector('[data-fixedFilter]') ?.classList.add('d-none') :  document.querySelector('[data-fixedFilter]')?.classList.remove('d-none');
                });
            });

            let isfilterForm = document.querySelector('[data-topFilter] .filter-box').classList.contains('d-none');
             !isfilterForm && document.querySelector('[data-fixedFilter]') != null ? observer.observe(document.querySelector('[data-topFilter]')) : document.querySelector('[data-fixedFilter]')?.classList.add('d-none');

         })
    }

    /**
     * Select the form field based on the btn click
     */
    selectMaterialform(){
        if(document.querySelectorAll('[data-selectMatrialCTA]')){
            document.querySelectorAll('[data-selectMatrialCTA]').forEach( (ele) => {
                ele.addEventListener('click', event => {
                    window.scrollTo(0,0);
                })
            }
            )   
        }
    }

    /**
     * sort the products based on the skus 
     */
    sortProducts(){
        try{
            document.addEventListener('DOMContentLoaded', function() {
                var productContainer = document.querySelector('#template-collection');
                var products = Array.from(productContainer.querySelectorAll('.collection-product'));
                var sortedProducts = products.map(function(product) {
                  var skuTag = product.dataset.sku;
                  var matchResult = skuTag.match(/sku-([^\s]+)/);
                  if (matchResult) {
                    var alphanumericPart = matchResult[1];
                    return { element: product, alphanumericPart: alphanumericPart };
                  } else {
                    console.error("Invalid SKU format:", skuTag);
                    return null;
                  }
                });
                sortedProducts = sortedProducts.filter(function(item) {
                  return item !== null;
                });
                sortedProducts.sort(function(a, b) {
                  return a.alphanumericPart.localeCompare(b.alphanumericPart, undefined, { numeric: true });
                });
                productContainer.innerHTML = '';
                sortedProducts.forEach(function(item) {
                  productContainer.appendChild(item.element);
                });
              });
        }
        catch(e){
            console.log(e)
        }
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 